import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import FilterArray from "../../components/forms/FilterArray";
import TextField from "../../components/forms/TextField";
import TextArea from "../../components/forms/TextArea";
import styled from "styled-components";
import {
	reqOptions,
	fetchAPI,
	HOST_URL,
	getCookie,
} from "../../assets/js/help_func";
import SubmitBtn from "../../components/forms/SubmitBtn";
import StatusMessage from "../../components/message/StatusMessage";

export default function ErrorFeedback() {
	const [rootPage, setRootPage] = useState(false);
	const [showForm, setShowForm] = useState(false);
	const toggleForm = () => setShowForm(!showForm);
	const [currentURL, setCurrentURL] = useState("");
	const [userID, setUserID] = useState("");

	const [data, setData] = useState(false);
	const [error, setError] = useState(false);
	const [status, setStatus] = useState(false);

	useEffect(() => {
		setCurrentURL(document.location.href);
		setUserID(getCookie("u_id"));

		if (data?.id) {
			setShowForm(false);
		}

		if (window.location.pathname === "/accounts/feedback") {
			setShowForm(true);
			setRootPage(true);
		}
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		let requestOptions = reqOptions("post", formData);

		fetchAPI(
			setData,
			HOST_URL + "/api/v1/error_logs/feedback/",
			requestOptions,
			true,
			setStatus,
			setError
		);
	};

	return (
		<ReactFeedback className={rootPage && "root_page"}>
			<StatusMessage
				status={status}
				setStatus={setStatus}
				message={
					status === 201
						? "Thank you for your feedback!"
						: status === 401 &&
						  "You do not have the permission to make this request."
				}
			/>
			<button onClick={toggleForm} className="toggle_feedback">
				<span className="material-symbols-outlined">chat_bubble</span>{" "}
				<span className="text">Feedback</span>
			</button>

			<motion.div
				className="feedback-form"
				initial={{ x: "100%" }}
				animate={{ x: showForm ? "0%" : "100%" }}
				transition={{ type: "spring", stiffness: 300, damping: 20 }}
			>
				{showForm && (
					<FeedbackForm
						handleSubmit={handleSubmit}
						currentURL={currentURL}
						userID={userID}
					/>
				)}
			</motion.div>
		</ReactFeedback>
	);
}

function FeedbackForm(props) {
	return (
		<form onSubmit={props.handleSubmit}>
			<h2>Send feedback to LeadBoard</h2>
			<FilterArray
				options={["FEATURE", "BUG", "IMPROVEMENT"]}
				labels="Feedback Type"
				names="type"
			/>
			<TextField types="file" labels="URL (optional)" names="screenshot" />
			<TextArea
				labels="Feedback Details"
				rows={5}
				names="description"
				helpText="Please don’t include any sensitive information (eg. login details)."
			/>
			<input type="url" name="url" defaultValue={props.currentURL} hidden />
			<input type="text" name="user" defaultValue={props.userID} hidden />

			<SubmitBtn labels="Submit Feedback" />
		</form>
	);
}

const ReactFeedback = styled.div`
	position: relative;
	.toggle_feedback {
		display: flex;
		align-items: center;
		margin-top: 0px;
		margin-bottom: 0px;
		span {
			display: inline-block;
		}
		.material-symbols-outlined {
			/* position: relative;
			top: 7px; */
			margin-right: 10px;
		}
		border: var(--borderDefault);
		padding: 10px;
		height: 50px;
	}
	form {
		h2 {
			font-size: 1.6em;
		}
		width: 550px;
		padding: 20px;
		position: absolute;
		right: 0px;
		background: var(--white);
		box-shadow: var(--shadow);
	}
	&.root_page {
		.toggle_feedback {
			display: none;
		}
		form {
			position: relative;
			margin: 50px auto;
		}
	}
	@media (max-width: 500px) {
		.toggle_feedback {
			border: none;
			span.text {
				display: none;
			}
		}
		form {
			min-width: 350px;
			width: 100%;
		}
	}
`;
